import { getCsrfCookie } from "./utils";

export type OnboardingEventName =
  | "onboarding_started"
  | "step_completed"
  | "onboarding_completed"
  | "onboarding_abandoned";

export async function trackOnboardingEvent(args: {
  eventName: OnboardingEventName;
  step?: string;
  payload?: Record<string, unknown>;
}) {
  const body = {
    event_name: args.eventName,
    step: args.step ?? "",
    payload: args.payload ?? {},
  };

  console.log("[onboarding-event]", body);

  try {
    await fetch("/api/reeprise/onboarding/events/", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "X-CSRFTOKEN": getCsrfCookie(),
      },
      credentials: "same-origin",
      keepalive: true,
      body: JSON.stringify(body),
    });
  } catch (error) {
    console.warn("failed to track onboarding event", error);
  }
}
